import { Info, Warning, CheckCircle, XCircle } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";

interface CalloutBlockProps {
  variant: "info" | "warning" | "success" | "error";
  text: string;
}

const VARIANT_STYLES: Record<
  string,
  { bg: string; border: string; icon: React.ReactNode }
> = {
  info: {
    bg: "bg-puntt-accent-2",
    border: "border-l-puntt-accent-9 border-puntt-accent-6",
    icon: <Info size={16} className="text-puntt-accent-9" weight="fill" />,
  },
  warning: {
    bg: "bg-puntt-gold-2",
    border: "border-l-puntt-gold-9 border-puntt-gold-6",
    icon: <Warning size={16} className="text-puntt-gold-11" weight="fill" />,
  },
  success: {
    bg: "bg-malachite-50",
    border: "border-l-malachite-600 border-malachite-300",
    icon: (
      <CheckCircle size={16} className="text-malachite-700" weight="fill" />
    ),
  },
  error: {
    bg: "bg-puntt-red-2",
    border: "border-l-puntt-red-9 border-puntt-red-6",
    icon: <XCircle size={16} className="text-puntt-red-9" weight="fill" />,
  },
};

export function CalloutBlock({ variant, text }: CalloutBlockProps) {
  const style = VARIANT_STYLES[variant] ?? VARIANT_STYLES.info;

  return (
    <div
      data-testid={`callout-block-${variant}`}
      className={`flex items-start gap-2.5 rounded-xl border border-l-4 ${style.border} ${style.bg} p-4 shadow-sm`}
    >
      <span aria-hidden="true" className="mt-0.5 shrink-0">
        {style.icon}
      </span>
      <Text
        size="2"
        className="text-puntt-neutral-gray-12"
        data-testid="callout-block-text"
      >
        {text}
      </Text>
    </div>
  );
}
